import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

import FAEventCardActions from './FAEventCardActions'
import FAEventCardHeader from './FAEventCardHeader'
import FAEventCardInformation from './FAEventCardInformation'
import FAEventCardMeta from './FAEventCardMeta'
import FAEventCardPicture from './FAEventCardPicture'

import { isInPast } from 'Global/Helpers/timeHelpers'

class FAEventCard extends Component {
  handleExportToExcel = e => {
    const { event, exportToExcel } = this.props

    e.preventDefault()

    exportToExcel(event.customerEmails)
  }

  render() {
    const { event } = this.props

    return (
      <Card color={event.current && !isInPast(event.dateEnd) ? 'green' : null} fluid>
        <FAEventCardPicture event={event} />

        <FAEventCardHeader event={event} />

        <FAEventCardInformation event={event} />

        <FAEventCardMeta event={event} />

        <FAEventCardActions exportToExcel={this.handleExportToExcel} />
      </Card>
    )
  }
}

FAEventCard.propTypes = {
  event: PropTypes.object.isRequired,
  exportToExcel: PropTypes.func.isRequired,
}

export default FAEventCard
